import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-popover.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlPopover = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlPopover, HTMLFmlPopoverElement>(
  'fml-popover',
  defineCustomElement
);
